module.exports = __webpack_public_path__ + "static/media/time.362a5ce4.svg";